module.exports = __webpack_public_path__ + "static/img/apply1.5dd8b670.png";